import { authRef, homeUrl } from 'config'

export const forgotPassword = (
  email: string,
  successCallback: () => void,
  errorCallback: (e) => void
) => async dispatch => {
  try {
    await authRef.sendPasswordResetEmail(email, {
      url: `${homeUrl}`,
      handleCodeInApp: true
    })
    successCallback()
  } catch (e) {
    errorCallback(e.message)
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/forgotPassword.action.ts